import styled, { css, DefaultTheme } from 'styled-components';
import CustomCard from '@components/CustomCard';

const getColorByPercentage = (percentage: number, theme: DefaultTheme) => {
  if (percentage > 100) {
    return theme.colors.red;
  }
  return theme.colors.blue;
};

export const CardProgressContainer = styled(CustomCard)`
  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    > strong {
      text-align: center;
      text-transform: uppercase;
      padding: 2px 0;
      width: 100%;

      svg {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const CardProgressBar = styled.div<{ percentage: number }>`
  width: 100%;
  display: flex;
  align-items: center;

  .progress-inner {
    height: 8px;
    width: 100%;
    border-radius: 40px;
    background: ${({ theme }) => theme.colors.content1};
    position: relative;

    .progress-bg {
      position: absolute;
      height: 100%;
      border-radius: ${({ percentage }) =>
        percentage < 100 ? '80px 0 0 80px' : '80px'};
      ${({ theme, percentage }) => css`
        background: ${getColorByPercentage(percentage, theme)};
        width: ${percentage > 100 ? 100 : percentage}%;
      `};
    }
  }

  .progress-value {
    margin-left: 8px;
    font-size: 1rem;
    font-weight: bold;
    color: ${({ theme, percentage }) =>
      getColorByPercentage(percentage, theme)} !important;
  }
`;

export const CardProgressFooter = styled.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.background1};
  border-radius: 4px;
  border: 1px dashed ${({ theme }) => theme.colors.border};
  padding: 4px 16px;

  strong {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  .shared-contracts-surplus {
    color: ${({ theme }) => theme.colors.red};
  }
`;

export const CardSurplus = styled.div`
  background: red;
`;
